<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Ville</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Pays :</label>
    </div>
    <div v-if="!libellesPaysLoading" class="col-4">
      <Dropdown
        v-model="pays"
        :options="paysLibelles"
        :showClear="true"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
    <div v-else class="col-4">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Province :</label>
    </div>
    <div v-if="!libellesProvinceLoading" class="col-4">
      <Dropdown
        v-model="province"
        :options="provinceLibelles"
        :showClear="true"
        :filter="true"
        optionValue="cle"
        optionLabel="description"
        scrollHeight="205px"/>
    </div>
    <div v-else class="col-4">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Ville :</label>
    </div>
    <div class="col-4">
      <InputText v-model="ville"/>
    </div>
  </div>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <div v-if="enregistrementEnCours == false">
        <Button @click="sauvegarder">Sauvegarder</Button>
      </div>
      <div v-else>
        <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
      </div>
    </div>
    <div class="col">
      <Button @click="fermer">Fermer</Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajout Ville");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.libellesPaysLoading = true;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Pays').then((res) => {
      this.paysLibelles = res.data;
      this.paysLibelles.sort(function (a, b) {
        if (a.texte < b.texte) {
          return -1;
        }
        if (a.texte > b.texte) {
          return 1;
        }
        return 0;
      });
      this.libellesPaysLoading = false;
    });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data(){
    return {
      ville: null,
      pays: null,
      province: null,
      provinceLibelles: [],
      paysLibelles: [],
      libellesPaysLoading: false,
      libellesProvinceLoading: false,
      enregistrementEnCours: false,
      code: 'Ville'
    }
  },
  methods: {
    sauvegarder(){
      if(this.province != null){
        this.enregistrementEnCours = true;

        let tableValeurLocal = {};
        tableValeurLocal.tableValeurVO = {};
        tableValeurLocal.tableValeurVO.code = this.code;
        tableValeurLocal.tableValeurVO.description = this.ville;
        tableValeurLocal.tableValeurVO.actif = true;
        tableValeurLocal.libelleVO = {};
        tableValeurLocal.libelleVO.texte = this.ville;

        this.$store.dispatch('pilotage/ajouterTableValeurAction', {
            ascendantCle: this.province,
            tableValeur: tableValeurLocal
        }).then(() => {
          this.enregistrementEnCours = false;
          this.$toast.add({
              severity: 'success',
              summary: 'Sauvegarder',
              detail: 'La ville a été ajoutée',
              life: 6000
          })
        }).catch(err => {
          this.$toast.add({
              severity: 'error',
              summary: 'Sauvegarder',
              detail: `Erreur lors de l'enregistrement du type: ${err}`,
              life: 6000
          })
          this.enregistrementEnCours = false;
        })
      }else {
        this.$toast.add({
            severity: 'error',
            summary: 'Sauvegarder',
            detail: 'Il faut une province pour ajouter la ville',
            life: 6000
        })
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
  watch: {
    pays: function (val) {
      if (val !== null && val !== undefined) {
        this.libellesProvinceLoading = true;
        let libelleRecherche = {};
        libelleRecherche.valeur = this.pays;
        libelleRecherche.enfant = {};
        libelleRecherche.enfant.code = 'Province';
        
        this.provinceLibelles = [];
        this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
          res.data.libelles.forEach((currentPays) => {
            currentPays.tableValeur.libelles.forEach((currentProvince) => {
              let currentProvinceComplete = currentProvince;
              currentProvinceComplete.clePays = currentPays.tableValeur.cle;
              currentProvinceComplete.pays = currentPays.tableValeur.description;
              this.provinceLibelles.push(currentProvinceComplete)
            })
          })
          this.provinceLibelles.sort(function (a, b) {
            if (a.description < b.description) {
              return -1;
            }
            if (a.description > b.description) {
              return 1;
            }
            return 0;
          });
          this.libellesProvinceLoading = false;
          this.province = null;
        });
      } else {
        this.province = null;
        this.provinceLibelles = [];
      }
    },
  }
    
}
</script>
